export default "__VITE_ASSET__78480f1b__"